module.exports = __webpack_public_path__ + "img/OGVH_14.6176445e.png";